import { useMemo } from "react";
import { useIntl } from "react-intl";

import { CollapsibleCard } from "@/components/CollapsibleCard/CollapsibleCard";
import { HotelFacilityList } from "@/features/hotels/components/hotel/HotelFacilityList";
import { buildHotelFacilitiesDisplayModel } from "@/features/hotels/utils/facilities/buildHotelFacilitiesDisplayModel";

type Props = {
  facilities: string | null | undefined;
};

export const RoomAmenitiesCard = ({ facilities }: Props) => {
  const intl = useIntl();

  const { groups } = useMemo(
    () => buildHotelFacilitiesDisplayModel(facilities),
    [facilities],
  );

  if (groups.length === 0) {
    return null;
  }

  return (
    <CollapsibleCard
      title={intl.formatMessage({
        defaultMessage: "Room Amenities",
        description: "Section heading for the hotel room amenities",
      })}
    >
      <HotelFacilityList facilityGroups={groups} />
    </CollapsibleCard>
  );
};
